const waterUnitTypes = [
    {value:"boiler", text:"Boiler"},
    {value:"coolingtower", text:"Cooling tower"},
    {value:"cip", text:"CIP"},
    {value:"coldgen", text:"Cold water - general"},
    {value:"coldprocess", text:"Cold water - process"},
    {value:"coldsanitation", text:"Cold water - sanitation"},
    {value:"hotgen", text:"Hot water - general"},
    {value:"hotprocess", text:"Hot water - process"},
    {value:"hotsanitation", text:"Hot water - sanitation"},
    {value:"main", text:"Main"},
    {value:"other", text:"Other"},
];

const electricUnitTypes = [
    {value:"ahu", text:"Air handling unit"},
    {value:"amu", text:"Air makeup unit"},
    {value:"battery", text:"Battery"},
    {value:"aircomp", text:"Air compressors"},
    {value:"nh3comp", text:"Ammonia compressors"},
    {value:"blowers", text:"Blowers"},
    {value:"co2comp", text:"CO2 compressors"},
    {value:"refcomp", text:"Compressors - misc"},
    {value:"condenser", text:"Condenser"},
    {value:"dehumidifier", text:"Dehumidifier"},
    {value:"evaporator", text:"Evaporator"},
    {value:"fan", text:"Fan"},
    {value:"heating_elem", text:"Heating element"},
    {value:"lighting", text:"Lighting"},
    {value:"main", text:"Main"},
    {value:"motor", text:"Motor"},
    {value:"other", text:"Other"},
    {value:"pump", text:"Pump"},
    {value:"rtu", text:"RTU"},
];

const gasUnitTypes = [
    {value:"boiler", text:"Boiler"},
    {value:"hotwater", text:"Hot water"},
    {value:"hvac", text:"HVAC"},
    {value:"main", text:"Main"},
    {value:"other", text:"Other"}
];

const steamUnitTypes = [
    {value: 'main', text: 'Main'},
    {value: 'boiler', text: 'Boiler'},
    {value: 'process', text: 'Process'},
    {value: 'other', text: 'Other'}
];

const temperatureUnitTypes = [
    {value:"ambient", text:"Ambient temperature"},
    {value:"hotwater", text:"Hot water line"},
    {value:"other", text:"Other"},
    {value:"test", text:"Test"},
];

const sensorSuppliers = [
    {value:"AlertLabs", utilities: ['water']},
    {value:"Edgecom", utilities: ['water', 'electricity', 'gas']},
    {value:"Centrica", utilities: []}, // leave empty as new sensors cant be synced going forward
    {value:"Milesight", utilities: ['water', 'electricity', 'gas', 'temperature']},
    {value:"Offline", utilities: ['water', 'electricity', 'gas', 'temperature']},
    {value:"SCADA", utilities: []}, // leave empty as case by case dev needed for now
]

module.exports = {
    waterUnitTypes,
    electricUnitTypes,
    gasUnitTypes,
    temperatureUnitTypes,
    steamUnitTypes,
    sensorSuppliers
}
